/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { configurationGet } from '../fn/configuration/configuration-get';
import { ConfigurationGet$Params } from '../fn/configuration/configuration-get';

@Injectable({ providedIn: 'root' })
export class ApiFromConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `configurationGet()` */
  static readonly ConfigurationGetPath = '/Configuration';

  /**
   * Retrieving service configuration settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configurationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationGet$Response(params?: ConfigurationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return configurationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieving service configuration settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configurationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationGet(params?: ConfigurationGet$Params, context?: HttpContext): Observable<void> {
    return this.configurationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
